module.exports = __webpack_public_path__ + "static/media/drawing.959edb2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/drawing.svg
// module id = 13
// module chunks = 0